import MUIDialogContent from '@mui/material/DialogContent';
import { FunctionComponent } from 'react';

import { DialogProps } from './types';

export interface DialogContentProps extends Pick<DialogProps, 'children'> {
  /** The ID of the dialog content */
  ariaID: string;
  /** The class name of the dialog content container */
  containerClass?: string;
}

/**
 * Content component that can be used to display the content of a dialog.
 * @param ariaID - the id of the dialog content
 * @param children - the content to display in the dialog content
 * @param containerClass - the class name of the dialog content container
 * @example
 * ```js
 * <DialogContent ariaID="dialog-content">
 *   <span>Hello, world.</span>
 * </DialogContent>
 * ```
 */
export const DialogContent: FunctionComponent<DialogContentProps> = ({
  ariaID,
  children,
  containerClass = '',
}) =>
  !children ? null : (
    <MUIDialogContent id={ariaID} className={containerClass}>
      {children}
    </MUIDialogContent>
  );
